import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae28d6ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = { class: "df mt-15 search-wrapper" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-list-wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "maintitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_item_mixed = _resolveComponent("item-mixed")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_multiple_selection_pop_up = _resolveComponent("multiple-selection-pop-up")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, { customTitle: _ctx.title }, {
          bottom: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_app_search, {
                  modelValue: _ctx.driveStore.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.search) = $event)),
                  onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.search = ''))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["ml-16 icon", _ctx.driveStore.isGridFolderView ? 'icon-tiles-2' : 'icon-list-view']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.isGridFolderView = !_ctx.driveStore.isGridFolderView))
              }, null, 2)
            ])
          ]),
          "top-left": _withCtx(() => [
            (!_ctx.showSelector)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0);",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
                  class: "back-link"
                }, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.showSelector)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSelector = false)),
                  class: "back-link"
                }, " Cancel "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["customTitle"]),
        _createElementVNode("div", {
          class: "scroll",
          ref: "scroller",
          onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          _createVNode(_component_item_mixed, {
            ref: "refMixed",
            mixedList: _ctx.mixed,
            column: !_ctx.driveStore.isGridFolderView,
            skeleton: _ctx.dataLoading,
            selector: _ctx.showSelector,
            loading: _ctx.isPageLoading
          }, null, 8, ["mixedList", "column", "skeleton", "selector", "loading"]),
          _withDirectives(_createVNode(_component_app_no_message, {
            icon: _ctx.noMixedMessage.icon
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.noMixedMessage.text), 1)
            ]),
            _: 1
          }, 8, ["icon"]), [
            [_vShow, !_ctx.mixed.length]
          ])
        ], 544),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          (_ctx.isSettingsPopUp)
            ? (_openBlock(), _createBlock(_component_multiple_selection_pop_up, {
                key: 0,
                onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSettingsPopUp = false)),
                onDelete: _ctx.deleteSelectedItems,
                "hide-move-to": ""
              }, null, 8, ["onDelete"]))
            : _createCommentVNode("", true)
        ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", null, [
          (!_ctx.showSelector)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:void(0);",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"])),
                class: "back-link"
              }, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.showSelector)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSelector = false)),
                class: "back-link"
              }, " Cancel "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "d-scroll",
          ref: "scroller",
          onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
        }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.mainTitle), 1),
          _createVNode(_component_item_mixed, {
            ref: "refMixed",
            mixedList: _ctx.mixed,
            column: !_ctx.driveStore.isGridFolderView,
            skeleton: _ctx.dataLoading,
            selector: _ctx.showSelector,
            loading: _ctx.isPageLoading
          }, null, 8, ["mixedList", "column", "skeleton", "selector", "loading"]),
          (_ctx.dataLoading)
            ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_app_no_message, {
            icon: _ctx.noMixedMessage.icon
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.noMixedMessage.text), 1)
            ]),
            _: 1
          }, 8, ["icon"]), [
            [_vShow, !_ctx.mixed.length && !_ctx.dataLoading]
          ])
        ], 544),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          (_ctx.isSettingsPopUp)
            ? (_openBlock(), _createBlock(_component_multiple_selection_pop_up, {
                key: 0,
                onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isSettingsPopUp = false)),
                onDelete: _ctx.deleteSelectedItems,
                "hide-move-to": ""
              }, null, 8, ["onDelete"]))
            : _createCommentVNode("", true)
        ]))
      ]))
}